import { DateTime, } from "luxon";
import { gql, } from ".";



/**
 * Calculates the annual percentage yield (APY) for block rewards based on BRKT price changes over the past week.
 * 
 * @returns {Promise<number>} The calculated APY as a decimal number (e.g., 0.05 for 5%)
 * 
 * @remarks
 * This function:
 * 1. Gets the current UTC date and time, zeroed out to midnight
 * 2. Calculates dates for today and one week ago
 * 3. Fetches BRKT price data for the specified period
 * 4. Extracts conversion rates for current and week-ago prices
 * 5. Calculates the annualized return based on the weekly price change
 */
export const getBlockRewardsAPY = async ():Promise<number> => {
	const now = DateTime.now().toUTC().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
	const today = now.toISO();
	const week_ago = now.minus({ days: 7, }).toISO();
	const { brkt_price_period, } = await gql<"BRKT_PRICE_PERIOD">("BRKT_PRICE_PERIOD", week_ago, today);
	const [ brkt_now, brkt_week_ago, ] = brkt_price_period;
	const { conv_rate:conv_rate_now, } = brkt_now;
	const { conv_rate:conv_rate_then, } = brkt_week_ago;
	const result = ((1+Number(conv_rate_now)-Number(conv_rate_then)) ** 52)-1;
	return result;
}